import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { initialize, reduxForm, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import M from 'materialize-css';

import FormButton from '../../components/UI/FormButton';
import { 
    renderFieldTwoColumns,
    renderSelectFieldTwoColumns,
    renderCheckFieldTwoColumns
} from '../../components/UI/Fileds';

import { setUserFilter } from '../../actions/user';

import { 
    fetchRoleList
} from '../../actions/ui';

const UserSearchForm = ({ submitting, handleSubmit }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { filter } = useSelector(state => state.user);

    const { roleList } = useSelector(state => state.ui);

    useEffect(() => {

        const collapsibles = document.querySelectorAll('.collapsible');
        M.Collapsible.init(collapsibles, {});

        dispatch(fetchRoleList()).then((res) => {
            if (res.ok) {
                const selects = document.querySelectorAll('select');
                M.FormSelect.init(selects, {});
            }
        });

        dispatch(initialize('userSearchForm', filter));

    }, [dispatch, filter]);
    
    const handleReset = () => {
        dispatch(setUserFilter({}));
    };

    const handleSearch = (values) => {
        const collapsibles = document.getElementsByClassName('collapsible-search-form');
        const instance = M.Collapsible.getInstance(collapsibles[0]);
        instance.close();

        dispatch(setUserFilter(values));
    }

    const renderForm = () => {
        return (
            <form className="search-form" onSubmit={ handleSubmit(handleSearch) }>

                <div className="row margin">
                    <Field type="text" name="username" id="username" 
                        label={ t('screens-user-list-username') } 
                        component={ renderFieldTwoColumns } 
                        icon="person" 
                        key="username" 
                    />

                    <Field type="text" name="email" id="email" 
                        label={ t('screens-user-list-email') } 
                        component={ renderFieldTwoColumns } 
                        icon="email" 
                        key="email" 
                    />
                </div>
                <div className="row margin">
                    <Field name="role_id" id="role_id" 
                        label={ t('screens-user-list-role') } 
                        component={ renderSelectFieldTwoColumns } 
                        icon="bookmark" 
                        key="role_id" 
                    >
                        <option value="">{ t('form-select-choose-one') }</option>
                        {
                            roleList.map(section => (
                                <option value={ section.id } key={ section.id }>{ section.description }</option>
                            ))
                        }
                    </Field>

                    <Field type="checkbox" name="active" id="active" 
                        className="filled-in"
                        label={ t('screens-user-list-active') } 
                        component={ renderCheckFieldTwoColumns } 
                        icon="check"
                        key="active"
                    />
                </div>

                <div className="row">
                    <div className="input-field col s12">
                        <FormButton type="submit"
                            title={ t('search-form-button-title') }
                            disabled={ submitting }
                        />

                        <FormButton type="reset"
                            title={ t('reset-form-button-title') }
                            disabled={ submitting }
                            onClick={ handleReset }
                        />
                    </div>
                </div>

            </form>
        );
    };

    return (
        <ul className="collapsible popout collapsible-search-form">
            <li>
                <div className="collapsible-header">
                    <i className="material-icons">tune</i> { t('filter-title') }
                </div>
                <div className="collapsible-body">
                    { renderForm() }
                </div>
            </li>
            
        </ul>
    );
};

const validate = (values) => ({});

export default reduxForm({
    form: 'userSearchForm',
    validate: validate,
    destroyOnUnmount: false
})(UserSearchForm);